import { useDispatch } from 'react-redux'

import actions from 'App/duck/actions'

export const useESalesTracking = (url): any => {
  const dispatch = useDispatch()
  // @ts-expect-error ts-migrate(2554) FIXME: Expected 0 arguments, but got 1.
  return (payload = {}) => dispatch(actions.trackESalesEvent({ url, ...payload }))
}

export default (id): any => {
  const dispatch = useDispatch()
  return (payload = {}) => dispatch(actions.trackEvent({ ...payload, id }))
}
